import { v4 as uuidv4 } from 'uuid';

import type { AnalyticsFlatRecord } from './analyticsEvent';

// Mismas claves, valores y clave de localStorage que el SDK de analítica (`useAnalytics` antes de
// CAM-16): hay procesos y consultas del lago que los usan, y el device_id no puede cambiar con la
// migración. `library` conserva el nombre del SDK por lo mismo.
export const DEVICE_ID_STORAGE_KEY = 'device_id';
const SDK_LIBRARY = '@oneclick/analytics-sdk';
const MOBILE_USER_AGENT = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

type NavigatorWithUserAgentData = Navigator & { userAgentData?: { platform?: string } };

let fallbackDeviceId: string | null = null;

function createDeviceId(): string {
  return `device_${uuidv4().replaceAll('-', '').slice(0, 9)}`;
}

function getDeviceId(): string {
  try {
    const storedId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (storedId) return storedId;

    const newId = createDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, newId);
    return newId;
  } catch {
    // Sin localStorage (navegación privada de Safari, almacenamiento bloqueado): estable en esta carga.
    fallbackDeviceId ??= createDeviceId();
    return fallbackDeviceId;
  }
}

function getOs(userAgent: string): string {
  if (userAgent.includes('Windows')) return 'Windows';
  if (userAgent.includes('Mac')) return 'macOS';
  if (userAgent.includes('Linux')) return 'Linux';
  if (userAgent.includes('Android')) return 'Android';
  if (userAgent.includes('iOS')) return 'iOS';
  return 'Unknown';
}

export function getDeviceContext(): AnalyticsFlatRecord {
  const browserNavigator = globalThis.navigator as NavigatorWithUserAgentData;
  const userAgent = browserNavigator?.userAgent ?? '';
  const os = getOs(userAgent);

  return {
    browser: userAgent,
    device_id: getDeviceId(),
    device_type: MOBILE_USER_AGENT.test(userAgent) ? 'mobile' : 'web',
    language: browserNavigator?.language || 'es',
    library: SDK_LIBRARY,
    os,
    platform: browserNavigator?.userAgentData?.platform || os,
    screen_height: globalThis.screen?.height ?? 0,
    screen_width: globalThis.screen?.width ?? 0,
  };
}
